import initApp from '@/main.common';
import AppStandalone from '@/AppStandalone.vue';
import routerStandalone from '@/router/router-standalone';
import { RuntimeConfig } from '@vp/common/api';
import { API } from '@vp/common';
import { auth, connection } from '@vp/vue-components';
import { handleSessionLapse } from '@/helpers/sessionLapseHandler';
import { SESSION_EXPIRED_SIGN_IN } from '@/components/superadmin/sessionExpiredSignIn';

import 'vue-toastification/dist/index.css';

import './index.css';
import * as Sentry from '@sentry/vue';

const pending: unknown[] = [];
window.addEventListener('error', e => pending.push(e.error ?? e.message));
window.addEventListener('unhandledrejection', e => pending.push(e.reason));

const initSentryOnce = (dsn: string) => {
  if (Sentry.getClient()) {
    return;
  }

  Sentry.init({
    dsn,
    tracesSampleRate: 1.0,
  });
  pending.splice(0).forEach(err => Sentry.captureException(err));
};

(async () => {
  const config = await RuntimeConfig.getRuntimeConfig();
  if (config.sentry?.dsn) {
    initSentryOnce(config.sentry.dsn);
  }
})();

// Standalone only: embedded, Rails owns sign-in and bounces a dead session itself.
const sessionLapseLink = connection.createSessionLapseLink({
  isSignedIn: () => auth.useAuthStore().isLoggedIn,
  hasSession: () => API.App.User.Api.hasSession(connection.useConnectionStore().gqlApiClient!),
  onLapse: () => handleSessionLapse(app, routerStandalone),
});

const app = initApp(AppStandalone, { middleware: [sessionLapseLink] });
app.use(routerStandalone);
app.provide(SESSION_EXPIRED_SIGN_IN, () => handleSessionLapse(app, routerStandalone));

app.mount('#app');
